import React from "react";
import { List, Button, Typography, Space, Empty, Card } from "antd";
import {
  ClockCircleOutlined,
  DeleteOutlined,
  ReloadOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

const SearchHistory = ({
  history,
  onUsePrompt,
  onRemovePrompt,
  onClearHistory,
  title = "Search History",
  emptyText = "No search history yet",
}) => {
  if (!history || history.length === 0) {
    return (
      <Card size="small" style={{ marginBottom: "16px" }}>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />
        {onClearHistory && (
          <div style={{ textAlign: "center", marginTop: "8px" }}>
            <Text type="secondary" style={{ fontSize: "12px" }}>
              Your search history will appear here
            </Text>
          </div>
        )}
      </Card>
    );
  }

  return (
    <Card size="small" title={title} style={{ marginBottom: "16px" }}>
      <List
        size="small"
        dataSource={history}
        renderItem={(item, index) => (
          <List.Item
            actions={[
              <Button
                type="text"
                size="small"
                icon={<ReloadOutlined />}
                onClick={() => onUsePrompt(item.prompt)}
                title="Use this prompt"
              />,
              <Button
                type="text"
                size="small"
                danger
                icon={<DeleteOutlined />}
                onClick={() => onRemovePrompt(item.prompt)}
                title="Remove from history"
              />,
            ]}
          >
            <List.Item.Meta
              avatar={<ClockCircleOutlined style={{ color: "#1890ff" }} />}
              title={
                <Text
                  style={{ cursor: "pointer", color: "#1890ff" }}
                  onClick={() => onUsePrompt(item.prompt)}
                >
                  {item.prompt}
                </Text>
              }
              description={
                <Text type="secondary" style={{ fontSize: "12px" }}>
                  {new Date(item.timestamp).toLocaleString()}
                </Text>
              }
            />
          </List.Item>
        )}
      />
      {onClearHistory && (
        <div style={{ textAlign: "center", marginTop: "8px" }}>
          <Button
            type="link"
            size="small"
            onClick={onClearHistory}
            style={{ color: "#ff4d4f" }}
          >
            Clear History
          </Button>
        </div>
      )}
    </Card>
  );
};

export default SearchHistory;
